export enum LateFeeType {
  Percentage = 1,
  FixedAmount = 2,
}

export function normalizeLateFeeType(
  value: LateFeeType | string | null | undefined
): LateFeeType | null {
  if (typeof value === 'number') return value;
  if (value === 'Percentage') return LateFeeType.Percentage;
  if (value === 'FixedAmount') return LateFeeType.FixedAmount;
  return null;
}

export interface LateFeePolicy {
  id: string;
  name: string;
  type: LateFeeType;
  value: number;
  graceDays: number;
  isTaxable: boolean;
  isActive: boolean;
}

export interface CreateLateFeePolicy {
  name: string;
  type: LateFeeType;
  value: number;
  graceDays: number;
  isTaxable: boolean;
}

export interface UpdateLateFeePolicy extends CreateLateFeePolicy {
  isActive: boolean;
}
